import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ContentCopyExtension } from 'common/ContentCopyExtension/ContentCopyExtension';
import React from 'react';
import { pxToRem } from 'src/common/utils/fonts';

export type InterimCellProps = {
  text: string;
  sx?: SxProps;
};

export const InterimCell: React.FC<InterimCellProps> = ({ text, sx }) => {
  return (
    <Box
      role="cell"
      sx={{
        whiteSpace: 'nowrap',
        lineHeight: pxToRem(21),
        py: 14,
        ...sx,
      }}
    >
      <ContentCopyExtension value={text ?? ''}>
        <Typography variant="text1" color="text.primary" data-testid="primaryText">
          {text || '-'}
        </Typography>
      </ContentCopyExtension>
    </Box>
  );
};
